<template>
  <div class="my-account" v-show="isActive">
    <form>
      <div class="row">
        <div class="col-md-12">
          <section class="mb-5">
            <div class="flex-container space-between">
              <h4 class="section-title">Your personal details</h4>
              <button role="button" @click.prevent="edit(1)" class="cta-edit">
                Edit
              </button>
            </div>
            <hr class="solid" />
            <template v-if="isReadOnly">
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Name</span>
                </div>
                <div class="col-md-7 col-12">
                  <span class="label-mute">{{ FirstName }} {{ LastName }}</span>
                </div>
              </div>
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Email address</span>
                </div>
                <div class="col-md-7 col-12">
                  <span class="label-mute">{{ Email }}</span>
                </div>
              </div>
            </template>
            <template v-if="!isReadOnly & (section == 1)">
              <AlertMessages />
              <div class="form-row">
                <div class="col-12 col-lg-4">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-1"
                      id="firstName"
                      aria-label="First Name"
                      aria-required="true"
                      v-model="FirstName"
                      @blur="$v.FirstName.$touch()"
                      :class="{ 'is-invalid': $v.FirstName.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">First name</span>
                    </div>
                  </div>
                  <div v-if="$v.FirstName.$error" class="feedback">
                    <span v-if="!$v.FirstName.required"
                      >This field is required</span
                    >
                    <span v-if="!$v.FirstName.minLength"
                      >First name must be at least 2 characters</span
                    >
                    <span v-if="!$v.FirstName.maxLength"
                      >First name must be less than 100 characters</span
                    >
                    <span v-if="!$v.FirstName.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>

                <div class="col-12 col-lg-4">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-1"
                      id="lastName"
                      aria-label="Last Name"
                      aria-required="true"
                      v-model="LastName"
                      @blur="$v.LastName.$touch()"
                      :class="{ 'is-invalid': $v.LastName.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Last name</span>
                    </div>
                  </div>
                  <div v-if="$v.LastName.$error" class="feedback">
                    <span v-if="!$v.LastName.required"
                      >This field is required</span
                    >
                    <span v-if="!$v.LastName.minLength"
                      >Last name must be at least 2 characters</span
                    >
                    <span v-if="!$v.LastName.maxLength"
                      >Last name must be less than 100 characters</span
                    >
                    <span v-if="!$v.LastName.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      type="text"
                      autocomplete="off"
                      class="text-field-4"
                      id="email"
                      aria-label="Email"
                      aria-required="true"
                      v-model="Email"
                      @blur="$v.Email.$touch()"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Email address</span>
                    </div>
                  </div>
                  <div v-if="$v.Email.$error" class="feedback">
                    <span v-if="!$v.Email.required"
                      >This field is required</span
                    >
                    <span v-if="!$v.Email.email && $v.Email.$dirty"
                      >Incorrect email format</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      type="text"
                      autocomplete="off"
                      class="text-field-4"
                      id="confirmEmail"
                      v-model="ConfirmEmail"
                      @blur="$v.ConfirmEmail.$touch()"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Confirm email address</span>
                    </div>
                  </div>
                  <div v-if="$v.ConfirmEmail.$error" class="feedback">
                    <span v-if="!$v.ConfirmEmail.required"
                      >This field is required</span
                    >
                    <span
                      v-if="!$v.ConfirmEmail.email && $v.ConfirmEmail.$dirty"
                      >Incorrect email format</span
                    >
                    <span v-if="!$v.ConfirmEmail.sameAsEmail"
                      >Emails must match</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row cta-group">
                <button
                  role="button"
                  class="cta-white-169"
                  :disabled="!this.unsavedChanges"
                  @click="save(1)"
                >
                  Save changes
                  <span
                    class="angle-right-white"
                    v-show="!showSavedTick"
                  ></span>
                  <span class="check-right-white" v-show="showSavedTick"></span>
                </button>
                <button role="button" class="cta-cancel" @click="cancel(1)">
                  Cancel
                </button>
              </div>
            </template>
          </section>
          <section class="mb-5">
            <div class="flex-container space-between">
              <h4 class="section-title">Password</h4>
              <button role="button" @click.prevent="edit(2)" class="cta-edit">
                Edit
              </button>
            </div>
            <hr class="solid" />

            <template v-if="isReadOnly">
              <div class="form-row field-wrapper">
                <div class="col-12">
                  <span class="label password">Password</span>
                </div>
              </div>
            </template>
            <template v-if="!isReadOnly & (section == 2)">
              <AlertMessages />
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      type="password"
                      class="text-field-4"
                      id="password"
                      ref="password"
                      v-model="Password"
                      @blur="$v.Password.$touch()"
                      :class="{ 'is-invalid': $v.Password.$error }"
                    />
                    <i @click.prevent="showPassword(1)" :class="iconId"></i>
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Current Password</span>
                    </div>
                  </div>
                  <div v-if="$v.Password.$error" class="feedback">
                    <span v-if="!$v.Password.required"
                      >This field is required</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper">
                    <input
                      type="password"
                      class="text-field-4"
                      id="newPassword"
                      v-model="NewPassword"
                      ref="newPassword"
                      @blur="$v.NewPassword.$touch()"
                      :class="{ 'is-invalid': $v.NewPassword.$error }"
                    />
                    <i @click.prevent="showPassword(2)" :class="iconNewId"></i>
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">New Password</span>
                    </div>
                  </div>
                  <div v-if="$v.NewPassword.$error" class="feedback">
                    <span v-if="!$v.NewPassword.required"
                      >This field is required</span
                    >
                    <span v-if="!$v.NewPassword.minLength"
                      >Password must be at least 8 characters</span
                    >
                    <span v-if="!$v.NewPassword.strongPassword"
                      >Password must contain a lowercase character, uppercase
                      character, a number and a special character</span
                    >
                  </div>
                  <p class="label-info">
                    Must be at least 8 characters and contain a lowercase
                    character, uppercase character, a number and a special
                    character.
                  </p>
                </div>
              </div>
              <div class="form-row cta-group">
                <button
                  role="button"
                  class="cta-white-169"
                  v-show="!showSavedTick"
                  :disabled="!this.unsavedChanges"
                  @click="save(2)"
                >
                  Save changes
                  <span
                    class="angle-right-white"
                    v-show="!showSavedTick"
                  ></span>
                  <span class="check-right-white" v-show="showSavedTick"></span>
                </button>
                <button role="button" class="cta-cancel" @click="cancel(2)">
                  Cancel
                </button>
              </div>
            </template>
          </section>
          <section class="mb-5">
            <div class="flex-container space-between">
              <h4 class="section-title">Organisation details</h4>
              <button role="button" @click.prevent="edit(3)" class="cta-edit">
                Edit
              </button>
            </div>
            <hr class="solid" />
            <template v-if="isReadOnly">
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Job title</span>
                </div>
                <div class="col-md-7 col-12">
                  <span class="label-mute">{{ JobTitle }}</span>
                </div>
              </div>
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Sector</span>
                </div>
                <div class="col-md-7 col-12">
                  <span class="label-mute">{{ Sector }}</span>
                </div>
              </div>
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Type of school/college</span>
                </div>
                <div class="col-md-7 col-12">
                  <span class="label-mute">{{ TypeOfSchool }}</span>
                </div>
              </div>
              <div class="row field-wrapper">
                <div class="col-md-5 col-12">
                  <span class="label">Organisation name and address</span>
                </div>
                <div class="col-md-7 col-12">
                  <span
                    class="label-mute"
                    v-if="
                      OrganisationName !== undefined &&
                        OrganisationName !== null &&
                        OrganisationName.length > 0
                    "
                    >{{ OrganisationName }}<br
                  /></span>
                  <span
                    class="label-mute"
                    v-if="
                      AddressLine1 !== undefined &&
                        AddressLine1 !== null &&
                        AddressLine1.length > 0
                    "
                    >{{ AddressLine1 }}<br
                  /></span>
                  <span
                    class="label-mute"
                    v-if="
                      AddressLine2 !== undefined &&
                        AddressLine2 !== null &&
                        AddressLine2.length > 0
                    "
                    >{{ AddressLine2 }}<br
                  /></span>
                  <span class="label-mute">{{ City }} {{ Postcode }}</span>
                </div>
              </div>
            </template>
            <template v-if="!isReadOnly & (section == 3)">
              <AlertMessages />
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-4"
                      id="jobTitle"
                      v-model="JobTitle"
                      @blur="$v.JobTitle.$touch()"
                      :class="{ 'is-invalid': $v.JobTitle.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder">
                      <span class="">Job Title</span>
                    </div>
                  </div>
                  <div v-if="$v.JobTitle.$error" class="feedback">
                    <span v-if="!$v.JobTitle.maxLength"
                      >Job title must be less than 100 characters</span
                    >
                    <span v-if="!$v.JobTitle.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper select-field-4" v-flyout>
                    <!-- <label> -->

                    <select
                      id="sector"
                      v-model="Sector"
                      @change="onChange($event)"
                      @blur="$v.Sector.$touch()"
                      :class="{ 'is-invalid': $v.Sector.$error }"
                      ><option
                        v-for="option in sectors"
                        :key="option.value"
                        :value="option.value"
                        >{{ option.value }}</option
                      >
                    </select>

                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">Sector</span>
                    </div>
                    <!-- </label> -->
                  </div>
                  <i v-if="!$v.Sector.$error" class="fa fa-check"></i>
                  <div v-if="$v.Sector.$error" class="feedback">
                    <span v-if="!$v.Sector.required"
                      >This field is required</span
                    >
                  </div>
                </div>
              </div>
              <div v-if="Sector === 'Education/School'">
                <div class="form-row">
                  <div class="col-12">
                    <div class="field-wrapper select-field-4" v-flyout>
                      <select
                        id="school"
                        v-model="TypeOfSchool"
                        @blur="$v.TypeOfSchool.$touch()"
                        :class="{ 'is-invalid': $v.TypeOfSchool.$error }"
                        ><option
                          v-for="option in schools"
                          :key="option.value"
                          :value="option.value"
                          >{{ option.value }}</option
                        >
                      </select>

                      <div class="field-placeholder" v-animate>
                        <span class="asterisk">Type of school/college</span>
                      </div>
                    </div>
<i v-if="!$v.TypeOfSchool.$error && this.TypeOfSchool !=null" class="fa fa-check"></i>
                    <div v-if="$v.TypeOfSchool.$error" class="feedback">
                      <span v-if="!$v.TypeOfSchool.customValidation"
                        >This field is required</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-4"
                      id="organ"
                      v-model="OrganisationName"
                      @blur="$v.OrganisationName.$touch()"
                      :class="{ 'is-invalid': $v.OrganisationName.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="asterisk">School/Organisation name</span>
                    </div>
                  </div>
                  <div v-if="$v.OrganisationName.$error" class="feedback">
                    <span v-if="!$v.OrganisationName.required"
                      >This field is required</span
                    >

                    <span v-if="!$v.OrganisationName.maxLength"
                      >School/Organisation name must be less than 100
                      characters</span
                    >
                    <span v-if="!$v.OrganisationName.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-4"
                      id="address1"
                      v-model="AddressLine1"
                      @blur="$v.AddressLine1.$touch()"
                      :class="{ 'is-invalid': $v.AddressLine1.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="">Address line 1</span>
                    </div>
                  </div>
                  <div v-if="$v.AddressLine1.$error" class="feedback">
                    <span v-if="!$v.AddressLine1.maxLength"
                      >Address line 1 must be less than 100 characters</span
                    >
                    <span v-if="!$v.AddressLine1.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-4"
                      id="address2"
                      v-model="AddressLine2"
                      @blur="$v.AddressLine2.$touch()"
                      :class="{ 'is-invalid': $v.AddressLine2.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="">Address line 2</span>
                    </div>
                  </div>
                  <div v-if="$v.AddressLine2.$error" class="feedback">
                    <span v-if="!$v.AddressLine2.maxLength"
                      >Address line 2 must be less than 100 characters</span
                    >
                    <span v-if="!$v.AddressLine2.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-lg-4 col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-1"
                      id="city"
                      v-model="City"
                      @blur="$v.City.$touch()"
                      :class="{ 'is-invalid': $v.City.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="">City</span>
                    </div>
                  </div>
                  <div v-if="$v.City.$error" class="feedback">
                    <span v-if="!$v.City.maxLength"
                      >City must be less than 100 characters</span
                    >
                    <span v-if="!$v.City.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="field-wrapper" v-flyout>
                    <input
                      class="text-field-1"
                      id="postcode"
                      v-model="Postcode"
                      @blur="$v.Postcode.$touch()"
                      :class="{ 'is-invalid': $v.Postcode.$error }"
                    />
                    <i class="fa fa-check"></i>
                    <div class="field-placeholder" v-animate>
                      <span class="">Postcode</span>
                    </div>
                  </div>
                  <div v-if="$v.Postcode.$error" class="feedback">
                    <span v-if="!$v.Postcode.maxLength"
                      >Postcode must be less than 20 characters</span
                    >
                    <span v-if="!$v.Postcode.characters"
                      >Characters and alphabets, hyphens and numbers are
                      allowed</span
                    >
                  </div>
                </div>
              </div>
              <div class="form-row cta-group">
                <button
                  role="button"
                  class="cta-white-169"
                  v-show="!showSavedTick"
                  :disabled="!this.unsavedChanges"
                  @click="save(3)"
                >
                  Save changes
                  <span
                    class="angle-right-white"
                    v-show="!showSavedTick"
                  ></span>
                  <span class="check-right-white" v-show="showSavedTick"></span>
                </button>
                <button role="button" class="cta-cancel" @click="cancel(3)">
                  Cancel
                </button>
              </div>
            </template>
          </section>
          <section class="mb-5">
            <div class="flex-container space-between">
              <h4 class="section-title">Keep up to date with NSPCC Learning</h4>
              <button role="button" @click.prevent="edit(4)" class="cta-edit">
                Edit
              </button>
            </div>
            <hr class="solid" />
            <template v-if="isReadOnly">
              <div class="row">
                <div class="col-md-12 col-12">
                  <span class="label-mute">{{
                    EmailOptIn
                      ? "Yes, I would like to receive emails."
                      : "No, I don’t like to receive emails."
                  }}</span>
                </div>
              </div>
            </template>
            <template v-if="!isReadOnly & (section == 4)">
              <AlertMessages />
              <p class="keep-up">
                We would like to keep you informed about our professional
                training, events, latest news, services and resources that may
                be relevant to you. Please let us know whether you’re happy to
                receive our emails:
              </p>
              <div class="form-row">
                <label class="checkbox label-info" for="emailOptIn"
                  >Yes I would like to receive emails.
                  <input
                    type="checkbox"
                    class="label-info"
                    id="emailOptIn"
                    v-model="EmailOptIn"/><span class="checkmark"></span
                ></label>
              </div>
              <div class="form-row cta-group">
                <button
                  role="button"
                  class="cta-white-169"
                  v-show="!showSavedTick"
                  :disabled="!this.unsavedChanges"
                  @click="save(4)"
                >
                  Save changes
                  <span
                    class="angle-right-white"
                    v-show="!showSavedTick"
                  ></span>
                  <span class="check-right-white" v-show="showSavedTick"></span>
                </button>
                <button role="button" class="cta-cancel" @click="cancel(4)" >
                  Cancel
                </button>
              </div>
            </template>
          </section>
          <a role="button" tabindex="0" class="delete-link" @click="deleteAccount" @keydown.enter="deleteAccount"> Delete account</a>
          <popup-modal ref="popup">
            <p>
              Are you sure you want to delete all your account data and saved
              assessments?
            </p>
            <div class="d-flex">
              <a role="button" tabindex="0"  class="cancel mr-auto my-auto" @click="cancelPopup(false)"
              @keydown.enter="cancelPopup(false)"
                >Cancel</a
              >
              <button
                role="button"
                class="cta-green-169"
                @click="confirmPopup(false)"
                @keydown.enter="confirmPopup(false)"
              >
                OK<span class="angle-right-green"></span>
              </button>
            </div>
          </popup-modal>
          <popup-modal ref="unsavedPopup">
            <p>
              You have not saved changes to your account. Are you sure you want
              to leave?
            </p>
            <div class="d-flex">
              <a role="button" tabindex="0" class="cancel mr-auto my-auto" @click="cancelPopup(true)" @keydown.enter="cancelPopup(true)"
                >Cancel</a
              >
              <button
                role="button"
                class="cta-green-169"
                @click="confirmPopup(true)"
                @keydown.enter="confirmPopup(true)"
              >
                OK<span class="angle-right-green"></span>
              </button>
            </div>
          </popup-modal>
        </div>
        <div class="space"></div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import {
  required,
  email,
  sameAs,
  minLength,
  maxLength,
  helpers
} from "vuelidate/lib/validators";
import AlertMessages from "../components/alert-messages";
import { SET_USER } from "../store/mutation-types";
import PopupModal from "../components/popup-modal";

// characters and alphabets, hyphens and numbers only
const characters = helpers.regex(
  "characters",
  /^[0-9a-zA-Z\u00C0-\u024F\u1E02-\u1EF3'\- ]+$/
);

export default {
  name: "OverviewMyAccount",
  components: { AlertMessages, PopupModal },

  validations() {
    if (this.section === 1) {
      return {
        FirstName: {
          required,

          maxLength: maxLength(100),
          minLength: minLength(2),
          characters
        },
        LastName: {
          required,
          maxLength: maxLength(100),
          minLength: minLength(2),
          characters
        },
        Email: {
          required,
          email
        },
        ConfirmEmail: {
          required,
          sameAsEmail: sameAs("Email")
        }
      };
    } else if (this.section === 2) {
      return {
        Password: {
          required
        },
        NewPassword: {
          required,
          minLength: minLength(8),
          strongPassword: password => {
            if (
              typeof password == "undefined" ||
              password == null ||
              password == ""
            )
              return true;
            return (
              // password.length >= 8 &&
              /[a-z]/.test(password) &&
              /[A-Z]/.test(password) &&
              /[0-9]/.test(password) &&
              /[!@#$%^&*(),.?":{}|<>]/.test(password)
            );
          }
        }
      };
    } else if (this.section === 3) {
      return {
        JobTitle: {
          maxLength: maxLength(100),
          characters
        },
        Sector: {
          required
        },

        TypeOfSchool: {
          customValidation(value, vm) {
             if (vm.Sector === "Education/School")
        {
         return  value?.length > 0;
        }
          return true;
            // if (typeof value == "undefined" || value == null || value == "")
            //   return true;
            // return value.length > 0 && vm.Sector == "Education/School";
          }
        },
        OrganisationName: {
          required,
          maxLength: maxLength(100),
          characters
        },
        AddressLine1: {
          maxLength: maxLength(100),
          characters
        },
        AddressLine2: {
          maxLength: maxLength(100),
          characters
        },
        City: {
          maxLength: maxLength(100),
          characters
        },
        Postcode: {
          maxLength: maxLength(20),
          characters
        }
      };
    }
    // else if (this.section ===4){
    // return {};
    // }
  },
  data() {
    return {
      isActive: true,
      isReadOnly: true,
      section: Number,
      sectors: [],
      schools: [],
      showEyeIcon: false,
      showNewEyeIcon: false,
      resolvePromise: undefined,
      rejectPromise: undefined,
      showSavedTick: false,
      unsavedChanges: false
    };
  },
  props: {
    satContent: {
      type: Object,
      default: () => {}
    }
  },
  async created() {
    await this.getContent();
    if (this.content.Sectors)
      this.sectors = this.content.Sectors.map(x => {
        return { value: x };
      });

    if (this.content.SchoolTypes)
      this.schools = this.content.SchoolTypes.map(x => {
        return { value: x };
      });
  },
  methods: {
    ...mapActions("alert", ["clear"]),
    ...mapActions("util", ["getContent"]),
    ...mapActions("users", ["updateUser", "deleteUser"]),
    onChange(event) {
      this.Sector = event.target.value;
       if (this.Sector !== "Education/School") {
         this.TypeOfSchool =null;
       }
    },
    showPassword(element) {
      // Password
      if (element === 1) {
        this.showEyeIcon = !this.showEyeIcon;
        if (this.$refs.password.type == "password") {
          this.$refs.password.type = "text";
        } else {
          this.$refs.password.type = "password";
        }
      } else {
        this.showNewEyeIcon = !this.showNewEyeIcon;
        if (this.$refs.newPassword.type == "password") {
          this.$refs.newPassword.type = "text";
        } else {
          this.$refs.newPassword.type = "password";
        }
      }
    },
    showPopup(unsaved) {
      if (unsaved) this.$refs.unsavedPopup.open();
      else this.$refs.popup.open();
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    async edit(selectedSection) {
      if (this.unsavedChanges) {
        const ok = await this.showPopup(true);
        if (ok) {
          this.unsavedChanges = false;
        } else return;
      }
      this.clear();
      if (selectedSection == 2) {
        this.Password = "";
        this.NewPassword = "";
      }
      this.section = selectedSection;
      this.isReadOnly = false;
    },
    async save(selectedSection) {
      this.section = selectedSection;
      this.isReadOnly = false;

      this.clear();

      // If a section doesn't have a validations we don't need to call $v
      if (selectedSection !== 4) {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }
      }
      this.showSavedTick = true;
      this.$emit("changesSavedOrCancelledInAccount");

      await this.updateUser({ user: this.user, section: selectedSection });

      if (!this.hasError) {
        this.isReadOnly = true;
        this.showSavedTick = false;
        this.unsavedChanges = false;
      }
    },
    cancel(selectedSection) {
      this.section = selectedSection;
      this.isReadOnly = true;
      this.clear();
      this.$v.$reset();
      this.$emit("changesSavedOrCancelledInAccount");
    },
    async deleteAccount() {
      const ok = await this.showPopup(false);
      if (ok) {
        await this.deleteUser(this.user);
        if (!this.hasError)
          window.location.href =
            window.location.origin + "/self-assessment-tools-login/#/";
      }
    },

    confirmPopup(unsaved) {
      if (unsaved) this.$refs.unsavedPopup.close();
      else this.$refs.popup.close();
      this.resolvePromise(true);
    },

    cancelPopup(unsaved) {
      if (unsaved) this.$refs.unsavedPopup.close();
      else this.$refs.popup.close();
      this.resolvePromise(false);
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    }
  },
  computed: {
    ...mapState("users", ["user"]),
    ...mapGetters("alert", ["hasError"]),
    ...mapState("util", ["content"]),
    iconId() {
      return this.showEyeIcon ? "eye-on" : "eye-off";
    },
    iconNewId() {
      return this.showNewEyeIcon ? "eye-on" : "eye-off";
    },

    Id: {
      get() {
        return this.user.Id;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Id: val });
      }
    },
    FirstName: {
      get() {
        return this.user.FirstName;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { FirstName: val });
      }
    },
    LastName: {
      get() {
        return this.user.LastName;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { LastName: val });
      }
    },
    Email: {
      get() {
        return this.user.Email;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Email: val });
      }
    },
    ConfirmEmail: {
      get() {
        return this.user.ConfirmEmail;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { ConfirmEmail: val });
      }
    },
    Password: {
      get() {
        return this.user.Password;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Password: val });
      }
    },
    NewPassword: {
      get() {
        return this.user.NewPassword;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { NewPassword: val });
      }
    },
    JobTitle: {
      get() {
        return this.user.JobTitle;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { JobTitle: val });
      }
    },
    TypeOfSchool: {
      get() {
        return this.user.TypeOfSchool;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { TypeOfSchool: val });
      }
    },
    Sector: {
      get() {
        return this.user.Sector;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Sector: val });
      }
    },
    OrganisationName: {
      get() {
        return this.user.OrganisationName;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { OrganisationName: val });
      }
    },

    AddressLine1: {
      get() {
        return this.user.AddressLine1;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { AddressLine1: val });
      }
    },
    AddressLine2: {
      get() {
        return this.user.AddressLine2;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { AddressLine2: val });
      }
    },
    City: {
      get() {
        return this.user.City;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { City: val });
      }
    },
    Postcode: {
      get() {
        return this.user.Postcode;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Postcode: val });
      }
    },

    EmailOptIn: {
      get() {
        let val = this.user.EmailOptIn;
        if (val == undefined) val = false;
        return val;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { EmailOptIn: val });
      }
    }
  },
  watch: {
    user: {
      handler() {
        this.$emit("inputChangedInAccount");
        this.unsavedChanges = true;
      },
      deep: true
    }
  }
};
</script>

<style lang="sass" scoped></style>
